<template>
  <div class="bodydiv">
    <div class="header">
      <!--<div class="header_logo"><img src="images/logo.png" width="140" height="47"></div> -->
      <p class="header_con">全能考试系统</p>
      <div class="qrcodeHint" style="position: absolute; width:380px; margin-left: 700px; ">
        <span><img src="qrcode_icon.png" style="float: left;height: 50px;"></span>
      </div>
      <div class="appQrcode2">
        <table style="background: white; border-collapse: separate; border-spacing: 3px;">
          <tr>
            <td style="text-align: center; font-weight:bold">
              扫码下载APP
            </td>
          </tr>
          <tr>
            <td>
              <img src="app_qrcode.png" style="height: 185px;">
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="lgn_bx">
      <div class="login_con">
        <div class="lgn_con">
          <h3 class="login_tit">考生登录</h3>
          <div class="login_con_bx_t">
            <span>账号登录</span>
            <!--<span>手机号登录</span> -->
          </div>
          <div class="login_con_bx_t_c">
            <ul class="login_con_bx_bl">
              <form id="loginForm" method="post" ref="loginForm">
                <li style="cursor: hand">
                  <span style="cursor: hand"
                    ><img src="@/assets/images/login_icon02.png"
                  /></span>
                  <input
                    type="text"
                    v-model="loginForm.loginName"
                    name="loginName"
                    id="loginName"
                    placeholder="请输入您的登录账户"
                    class="telbt"
                  />
                </li>

                <li>
                  <span><img src="@/assets/images/login_icon01.png"/></span>
                  <input
                    type="password"
                    v-model="loginForm.loginPwd"
                    name="loginPwd"
                    id="loginPwd"
                    placeholder="输入密码"
                    class="telbt"
                  />
                </li>
                <li style="border:none">
                  <div class="rzm">
                    <input
                      type="text"
                      v-model="loginForm.captcha"
                      name="captcha"
                      id="captcha"
                      placeholder="输入图形验证码"
                      class="telbt"
                      style="width:160px;"
                    />
                  </div>
                  <div class="rzm_btn">
                    <el-image class="captcha-img" style="width:110px" :src="captchaPath" @click="getCaptcha()"/>
                  </div>
                </li>
                <li style="border:none; background:none">
                  <a class="login_btn" @click="loginHandle">登录</a>
                </li>
                <p class="help_con">
                  <!--<a class="sp1">登录帮助</a> --><router-link
                    to="/resetPassword"
                    class="sp2"
                    >忘记密码?</router-link
                  >
                </p>
              </form>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      Copyright © 2020~2023 ntceonline.com All Rights Reserved.<br />
      <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备18133849号</a>
    </div>
  </div>
</template>

<script>
import { getCaptchaImg, login, checkToken } from "@/api/login";

export default {
  name: "Login",
  data() {
    return {
      captchaPath: "",
      loginForm: {
        loginName: "",
        loginPwd: "",
        captcha: "",
        uuid: "",
        token: "",
        deviceType: "",
        deviceMode: "",
        systemVersion: "",
        softwareVersion: ""
      },
      tokenBean: {
        token: ""
      },
      loading: false,
      redirect: undefined
    };
  },
  created() {
    // 浏览器检测
    // const useragent = navigator.userAgent;

    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    const isAndroid = ua.indexOf("android") != -1;
    const isIos = ua.indexOf("iphone") != -1 || ua.indexOf("ipad") != -1;

    const isIE = window.ActiveXObject || "ActiveXObject" in window;
    if (isWeixin || isAndroid || isIos) {
      document.head.innerHTML =
        '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/connect/zh_CN/htmledition/style/wap_err1a9853.css">';
      document.body.innerHTML =
        '<div class="page_msg"><div class="inner"><span class="msg_icon_wrp"><i class="icon80_smile"></i></span><div class="msg_content"><h4>暂不支持在微信和手机浏览器进行考试</h4></div></div></div>';
    } else if (isIE) {
      document.head.innerHTML =
        '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/connect/zh_CN/htmledition/style/wap_err1a9853.css">';
      document.body.innerHTML =
        '<div class="page_msg"><div class="inner"><span class="msg_icon_wrp"><i class="icon80_smile"></i></span><div class="msg_content"><h4>温馨提示，本考试系统不支持IE浏览器，请更换到其它浏览器\n给您带来不便，敬请谅解</h4></div></div></div>';
    } else {
      if (this.getToken() === undefined) {
        this.getCaptcha();
      } else {
        this.tokenBean.token = this.getToken();
        checkToken(this.tokenBean).then(res => {
          if (res.data.code === 200) {
            this.$router.push("/");
            return;
          } else {
            this.getCaptcha();
          }
        });
      }
    }
    // const agent = useragent.toLowerCase();
    // if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
    //   alert("这是windows32位系统");
    // }
    // if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
    //   alert("这是windows64位系统");
    // }
    // var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    // if (isMac) {
    // alert("请使用Windows系统参与考试。");
    // 以下代码是用javascript强行关闭当前页面
    // const opened = window.open("about:blank", "_self");
    // opened.opener = null;
    // opened.close();
    // return;
    // }
    // if (useragent.match(/MicroMessenger/i) === "MicroMessenger") {
    // 这里警告框会阻塞当前页面继续加载
    // alert("不允许通过微信内置浏览器考试，建议使用谷歌，火狐等专业浏览器参与考试。");
    // const opened = window.open("about:blank", "_self");
    // opened.opener = null;
    // opened.close();
    // }
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      getCaptchaImg().then(res => {
        this.captchaPath = res.data.captcha;
        this.loginForm.uuid = res.data.uuid;
      });
    },
    loginHandle() {
      if (this.loginForm.loginName === "") {
        this.$message.error("请输入用户名");
        this.$refs.loginForm.loginName.focus();
        return;
      }
      if (this.loginForm.loginPwd === "") {
        this.$message.error("请输入密码");
        this.$refs.loginForm.loginPwd.focus();
        return;
      }
      if (this.loginForm.captcha === "") {
        this.$message.error("请输入图形验证码");
        this.$refs.loginForm.captcha.focus();
        return;
      }
      let userAgent = window.navigator.userAgent.toLowerCase();
      const browserinfo = userAgent.split("/");
      console.log(browserinfo);
      this.loginForm.deviceType = browserinfo[0];
      this.loginForm.systemVersion = browserinfo[1];
      this.loginForm.deviceMode = browserinfo[3];
      this.loginForm.softwareVersion = browserinfo[2];
      console.log(this.loginForm);
      // 检测token是否存在
      this.tokenBean.token = this.getToken();
      checkToken(this.tokenBean).then(res => {
        if (res.data.code === 200) {
          this.$message.error("不能同时登录多个用户，请退出当前用户再重新登录");
          return;
        } else {
          login(this.loginForm).then(res => {
            if (res.code === 200) {
              // this.$store.dispatch("setToken", res.data.token);
              // this.$router.push({ path: "/", query: { token: res.data.token } });
              console.log(res.data.token);
              this.removeUserInfo();
              this.setToken(res.data.token);
              this.setUserInfo(res.data.user);
              this.$router.push("/");
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    }
  }
};
</script>

<style>
.bodydiv {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: "Microsoft YaHei", "Arial", "Helvetica", "sans-serif";
  background-color: white;
}

.appQrcode2 {
  height: 200px;
  display: none;
  z-index: 9999;
  position: fixed;
  margin-left: 700px;
  margin-top: 60px;
}
.qrcodeHint:hover + .appQrcode2 {
  display: block;
}

</style>
